export default Object.freeze({
    ACTIVE: 'active',
    DEACTIVATED: 'deactivated'
  });
  